// extracted by mini-css-extract-plugin
module.exports = {"pickup-address":"_1k6eD","pickupAddress":"_1k6eD"};